module.exports = __webpack_public_path__ + "img/2695-7.48f8575d.png";